var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0372 10.1181V16.8363C20.0372 18.5591 18.6355 19.961 16.9125 19.961H3.16375C1.44089 19.961 0.0390625 18.5591 0.0390625 16.8363V3.08749C0.0390625 1.36446 1.44089 -0.0373611 3.16375 -0.0373611H12.1083C12.5398 -0.0373611 12.8895 0.312523 12.8895 0.743889C12.8895 1.17541 12.5398 1.52514 12.1083 1.52514H3.16375C2.30224 1.52514 1.60141 2.22598 1.60141 3.08749V16.8363C1.60141 17.6978 2.30224 18.3986 3.16375 18.3986H16.9125C17.774 18.3986 18.4749 17.6978 18.4749 16.8363V10.1181C18.4749 9.68661 18.8246 9.33688 19.2561 9.33688C19.6875 9.33688 20.0372 9.68661 20.0372 10.1181ZM18.2448 4.40936C18.3932 4.55691 18.475 4.75268 18.475 4.9605C18.475 5.16848 18.3932 5.3641 18.2448 5.51165L15.112 8.62475C14.806 8.92886 14.8045 9.42355 15.1086 9.72949C15.2612 9.88314 15.462 9.96005 15.6627 9.96005C15.8618 9.96005 16.0609 9.88436 16.2134 9.733L19.3461 6.6199C19.7918 6.17678 20.0374 5.58764 20.0374 4.9605C20.0374 4.33337 19.7918 3.74407 19.3461 3.30111L16.2134 0.188011C15.9074 -0.116096 15.4127 -0.114571 15.1086 0.191521C14.8045 0.497612 14.806 0.99215 15.112 1.29626L18.2448 4.40936ZM16.561 4.92327C16.561 4.49175 16.2112 4.14202 15.7799 4.14202C12.9629 4.14202 10.3146 5.23898 8.32274 7.23086C6.33086 9.22274 5.23391 11.8711 5.23391 14.688V15.2739C5.23391 15.7053 5.58364 16.055 6.01516 16.055C6.44653 16.055 6.79626 15.7053 6.79626 15.2739V14.688C6.79626 9.73437 10.8263 5.70437 15.7799 5.70437C16.2112 5.70437 16.561 5.35464 16.561 4.92327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.300ee938a707f2dcc27598d2685e3dfa.svg";
export { ForwardRef as ReactComponent };